import { FC, useContext, useEffect, useRef, useState } from 'react';

import { BottomIcon, Button, TopIcon } from '@smartshell/ui-kit';
import cn from 'classnames';

import { LocalizationContext } from 'localization';
import { openConfirmDialog } from 'services/Confirmation';
import { ESyncScope } from 'types';

import s from '../ApplicationManager.module.scss';
import { IButtonProps } from './interfaces';

export const SaveButton: FC<IButtonProps> = ({
  loadedShortcut,
  onSyncScopeChange,
}) => {
  const { t } = useContext(LocalizationContext);

  const dropdownSaveRef = useRef<HTMLDivElement>(null);
  const [isOpenSave, setIsOpenSave] = useState<boolean>(false);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (
        isOpenSave &&
        dropdownSaveRef.current &&
        !dropdownSaveRef.current.contains(event.target as Node)
      ) {
        setIsOpenSave(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpenSave]);

  return (
    <div className={s.button_block}>
      <Button
        fullWidth
        onClick={() => {
          setIsOpenSave(!isOpenSave);
        }}
        className={s.button}
      >
        {t(loadedShortcut ? 'save' : 'create')}
      </Button>
      <div className={s.arrow} onClick={() => setIsOpenSave(!isOpenSave)}>
        {isOpenSave ? (
          <TopIcon size="l" color={'light'} />
        ) : (
          <BottomIcon size="l" color={'light'} />
        )}
      </div>
      {isOpenSave && (
        <div ref={dropdownSaveRef} className={cn(s.dropdown)}>
          <div
            className={cn(s.drop_item)}
            onClick={() => {
              onSyncScopeChange(ESyncScope.LOCAL);
              setIsOpenSave(false);
            }}
          >
            {t('application.manager.button_3')}
          </div>
          <div
            className={cn(s.drop_item)}
            onClick={() =>
              openConfirmDialog(t, 'confirm', {
                title: t(
                  !loadedShortcut
                    ? 'modal.create.club.network.title'
                    : 'application.manager.modal.save'
                ),
                message: t(
                  !loadedShortcut
                    ? 'modal.create.club.network.description'
                    : 'application.manager.modal.save.text'
                ),
                acceptTitle: t(!loadedShortcut ? 'create' : 'save'),
                declineTitle: t('cancel'),
              }).then(({ status }) => {
                if (status === 'ACCEPTED') {
                  onSyncScopeChange(ESyncScope.NETWORK);
                  setIsOpenSave(false);
                }
              })
            }
          >
            {t('application.manager.button_4')}
          </div>
        </div>
      )}
    </div>
  );
};
